// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";

export class FirebaseRestClient {
  private apiKey: string;
  private authDomain: string;
  private projectId: string;
  private storageBucket: string;
  private messagingSenderId: string;
  private appId: string;

  constructor(
    apiKey: string,
    authDomain: string,
    projectId: string,
    storageBucket: string,
    messagingSenderId: string,
    appId: string
  ) {
    this.apiKey = apiKey;
    this.authDomain = authDomain;
    this.projectId = projectId;
    this.storageBucket = storageBucket;
    this.messagingSenderId = messagingSenderId;
    this.appId = appId;
  }

  public createClient() {
    // Your web app's Firebase configuration
    const firebaseConfig = {
      apiKey: this.apiKey,
      authDomain: this.authDomain,
      projectId: this.projectId,
      storageBucket: this.storageBucket,
      messagingSenderId: this.messagingSenderId,
      appId: this.appId,
    };

    initializeApp(firebaseConfig);
  }
}
